module.exports = __webpack_public_path__ + "media/images/prop-img-1920-f940bdc513a4483050e1ce003f415675.svg";